import Vue from 'vue'
import Router from 'vue-router'

import Painter from '@/components/Painter'
import Works from '@/components/Works'
import About from '@/components/About'
import PainterDetail from '@/components/PainterDetail'
import WorkDetail from '@/components/WorkDetail'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Painter',
      component: Painter
    },
    {
      path: '/works/:keyWord',
      name: 'Works',
      component: Works
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/painterDetail/:painterId',
      name: 'PainterDetail',
      component: PainterDetail
    },
    {
      path: '/workDetail/:workId',
      name: 'WorkDetail',
      component: WorkDetail
    },
  ]
})

router.beforeEach((to, from, next) => {
    const { path } = to;

    _hmt.push(['_trackPageview', path]);

    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js